import React from "react";
import { makeStyles } from "@material-ui/core";
import CardFaq from './accordion';

let responsiveLength = "1000";


let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        flexDirection: 'column',
        margin:'70px auto',
        maxWidth:'100%',
        '@media (max-width: 1100px)': {
            width: '100%',
            minWidth: 'unset',
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        right:'calc(50% - 15px)',
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    title: {
        fontSize: 30,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '100%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div style={{position:'relative'}}>
                       <div className={classes['line']} />
                        <h3 className={classes['title']}>
                        سوالات متداول
                        </h3>
            </div>
            <CardFaq data={data} />
        </div>)
}


let data = [
    {
        question: 'با چه مبلغی می‌توانم سرمایه‌گذاری را شروع کنم؟',
        answer: [
            "در حال حاضر حتی با مبلغ ۱۰۰ هزار تومان نیز می‌توانید در یکی از صندوق‌ها سرمایه‌گذاری کنید."
        ]
    },
    {
        question: 'آیا روشی برای سرمایه‌گذاری وجود دارد که هیچ میزانی از ریسک نداشته باشد؟',
        answer: [
            `خیر، هر شاخه‌ای از سرمایه‌گذاری، درجاتی از ریسک را دربر می‌گیرد. کم ریسک‌ترین نوع سرمایه‌گذاری صندوق‌های درآمد ثابت هستند. غالب دارایی این صندوق‌ها را اوراق با درآمد ثابت تشکیل می‌دهد. `
        ]
    },
    {
        question: 'در هنگام سرمایه‌گذاری چه ارکانی را باید مد نظر داشت؟',
        answer: [
            "میزان ریسک‌پذیری، هدف از سرمایه‌گذاری، عوامل مالی مانند میزان درآمد، مخارج روزمره، بدهی‌ها و…"
        ]
    },
    // {
    //     question: '',
    //     answer: [
    //        ""
    //     ]
    // },
]